<div class="container px-4 py-10">
  <block-ui>
    <div class="w-full p-2 m-2">
      <!-- Header Section -->
      <div class="flex items-center justify-between">
        <div class="mb-7">
          <h1 class="mb-1 text-2xl font-semibold text-primary-200">
            Invoices
          </h1>
          <p class="text-sm text-primary-500">View all of Your Invoices</p>
        </div>
        <div class="flex gap-2">
          <p-button icon="pi pi-download" label="Export" severity="secondary"></p-button>
            <p-button icon="pi pi-plus" label="Add New" severity="primary" (onClick)="addInvoice()"></p-button>
        </div>
      </div>
      <div class="flex items-center justify-between w-full">
        <p-breadcrumb class="max-w-full" [model]="breadCrumbItems" [home]="home" />
      </div>

      <!-- Tabs -->
      <p-tabMenu
        [model]="tabs"
        [activeItem]="activeTab"
        class="mt-4 border-b"></p-tabMenu>
    </div>
    <div *ngIf="!this.loading" class="w-full p-2 m-2">
          <p-table
    #dt2
      dataKey="id"
      stripedRows
      [value]="filtered_invoices"
      responsiveLayout="scroll"
      [scrollable]="true"
      [resizableColumns]="true" 
      [expandedRowKeys]="expandedRows" (onRowExpand)="onRowExpand($event)" (onRowCollapse)="onRowCollapse($event)"
      dataKey="id"
        [autoLayout]="true"
      [paginator]="true"
      [rows]="50"
      selectionMode="single"
      [globalFilterFields]="['customer.name', 'created_at', 'due_date', 'status', 'including_tax']"
      (onRowSelect)="rowSelected()"
      [(selection)]="selectedInvoice"
      [tableStyle]="{ 'min-width': '50rem' }"
      [rowsPerPageOptions]="[50, 100, 200]"
    >
    <ng-template #emptymessage>
        <tr>
            <td colspan="6">No invoices found.</td>
        </tr>
    </ng-template>
    
    <ng-template #caption>
      <div class="flex">
        <p-iconfield iconPosition="left">
          <p-inputicon>
              <i class="pi pi-search"></i>
          </p-inputicon>
          <input pInputText class="w-full ml-10" type="text" (input)="filter($event, dt2)" placeholder="Search keyword" />
      </p-iconfield>
      <p-button class="ml-auto" label="Clear" [outlined]="true" icon="pi pi-filter-slash" (click)="clear(dt2)" />
      </div>
      <div class="flex">
        <p-iconfield iconPosition="left">
          <p-inputicon>
              <i class="pi pi-calendar"></i>
          </p-inputicon>
          <p-select [options]="dateOptions" [(ngModel)]="selectedDate" (onChange)="valueChanged()" placeholder="Select a Date Range" class="w-full md:w-56" />
      </p-iconfield>
      </div>
    </ng-template>

  <!-- Table Header -->
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th style="width: 3rem"></th>
          <th pResizableColumn pSortableColumn="invoice_number">
            Invoice # <p-sortIcon field="invoice_number" />
           </th>
           <th pResizableColumn pSortableColumn="customer.name">
           Customer <p-sortIcon field="customer.name" />
          </th>
          <th pResizableColumn pSortableColumn="createdAt">
            Date <p-sortIcon field="createdAt" />
           </th>
           <th pResizableColumn pSortableColumn="createdAt">
            Due Date <p-sortIcon field="due_date" />
           </th>
           <th pResizableColumn pSortableColumn="status">
            Status <p-sortIcon field="status" />
           </th>
           <th pResizableColumn pSortableColumn="including_tax">
            Amount <p-sortIcon field="including_tax" />
           </th>
           <th></th>
         </tr>
      </ng-template>

      <!-- Table Body -->
      <ng-template pTemplate="body" let-rowData let-columns="columns"  let-expanded="expanded">
        <tr [pSelectableRow]="rowData">
          <td>
            <button
              type="button"
              pButton
              pRipple
              [pRowToggler]="rowData"
              class="p-button-text p-button-rounded p-button-plain"
              [icon]="
                expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'
              "></button>
          </td>
          <td>
            <a
            *ngIf="rowData.id"
            [routerLink]="['/admin/invoices/view', rowData.id]"
            class="text-blue-600 hover:underline">
            {{ rowData.invoice_number }}
          </a>
          <span *ngIf="!rowData.id">
            {{rowData.invoice_number}}
          </span>
          </td>
            <td>
              <a
              *ngIf="rowData.customer?.id"
              [routerLink]="['/admin/customers/view', rowData.customer?.id]"
              class="text-blue-600 hover:underline">
              {{rowData.customer?.name}}
            </a>
            <span *ngIf="!rowData.id">
              {{rowData.customer?.name}}
            </span>
          </td>
          <td>
            {{rowData.createdAt | date}}
          </td>
          <td>
            {{rowData.due_date | date}}
          </td>
          <td>
            <span [ngClass]="rowData.status === 'PAID' ? 'green' : rowData.status === 'Pending' ? 'orange' : 'red'">
              {{rowData.status}}
            </span>
          </td>
          <td style="text-align: right">
            {{rowData.including_tax | currency: 'USD'}}
          </td>
          <td>
            <p-button (click)="activeItem = rowData; menu.toggle($event)" icon="pi pi-ellipsis-v"/>
          </td>
        </tr>
      </ng-template>
      <ng-template #expandedrow let-rowData>
        <tr>
          <td colspan="8">
            <div class="p-4">
              <p-table [value]="rowData.lines?.data">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Line Type</th>
                    <th>Description</th>
                    <th class="text-right">Period Start</th>
                    <th class="text-right">Period End</th>
                    <th class="text-right">Quantity</th>
                    <th class="text-right">Unit Amount</th>
                    <th class="text-right">Discount</th>
                    <th class="text-right">Amount</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-lineData>
                  <tr>
                    <td>{{ lineData.line_type }}</td>
                    <td>{{ lineData.subscription.name }}</td>
                    <td class="text-right">{{ lineData.period_start | date:'mediumDate' }}</td>
                    <td class="text-right">{{ lineData.period_end | date:'mediumDate' }}</td>
                    <td class="text-right">{{ lineData.quantity }}</td>
                    <td class="text-right">{{ lineData.unit_price | currency : "USD" }}</td>
                    <td class="text-right">{{ lineData.discount_total | currency : "USD" }}</td>
                    <td class="text-right">
                      {{
                        lineData.line_total
                          | currency : "USD"
                      }}
                    </td>
                  </tr>
                </ng-template>
                <ng-template #emptymessage>
                  <tr>
                    <td colspan="4">No invoice lines found for this invoice.</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </td>
        </tr>
      </ng-template>
      </p-table>
    <p-menu appendTo="body" #menu [model]="items" [popup]="true" />
    </div>  
  </block-ui>
</div>
<div *ngIf="this.loading" class="p-8 text-center">
  <p class="text-gray-500">Loading customer data...</p>
</div>
<div *ngIf="this.error" class="p-8 text-center">
  <p class="text-red-500">Error getting customer data... try again!</p>
</div>
